import * as THREE from 'three';
import { LODToaster } from './LODToaster';
import { UpdatePriority } from './DynamicObject';

/**
 * Large toaster - elephant sized and slow moving
 */
export class LODToasterLarge extends LODToaster {
  constructor() {
    // Create with large toaster specific configuration
    // Elephant-sized and low speed
    super(
      'LODToasterLarge', 
      new THREE.Vector3(3.0, 3.0, 3.0),  // 3.0 meters in size (elephant-sized)
      0.7  // Slowest movement speed
    );
    
    // The SpatialManager will dynamically adjust priority based on distance and visibility
  }
  
  /**
   * Override health initialization for large toasters
   * Large toasters have high health but move slowly
   */
  protected override initializeHealth(): void {
    // Large toasters have 350 health
    this.maxHealth = 350;
    this.currentHealth = this.maxHealth;
    
    console.log(`Initialized large toaster ${this.getId()} with ${this.maxHealth} health`);
  }
} 